export default {"src":"/_next/static/media/InsuranceGroup-2_vertical.4cf279ae.svg","height":534,"width":87};